module.exports = __webpack_public_path__ + "media/images/common/ico-text-bubble-0ddb8484a794177e9643280626ec32e0.svg";